import styled, { keyframes } from "styled-components";
import LoaderSVG from "./components/Loader";
import LoaderSVGAndroid from "./components/LoaderAndroid";

const imageWH = () => {
  return 40;
};

const RotateKeyFrames = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(90deg);
  }
`;

export const OverlayWrapper = styled.div`
  position: fixed;
  background-color: hsla(0, 0%, 96%, 0.6);
  width: 100vw;
  height: 100vh;
  z-index: 9999;
`;

export const RotateImage = styled.div`
  animation: ${RotateKeyFrames} 0.25s forwards infinite;
  width: ${imageWH()}px;
  height: ${imageWH()}px;
  position: absolute;
  left: calc(50% - ${imageWH() / 2}px);
  top: calc(50% - ${imageWH() / 2}px);
`;

export const LoaderIcon = styled(LoaderSVG)`
  width: 40px;
  height: 40px;
`;

export const LoaderIconAndroid = styled(LoaderSVGAndroid)`
  width: 30px;
  height: 30px;
`;
